export const ApiResource = {
  Bearing: '/bearing',
  Connections: '/connections',
  Vp3701Device: '/vp3701',
  Generators: '/generators',
  Images: '/images',
  Info: '/info',
  Kinematic: '/kinematic',
  Measurements: '/measurements',
  Mnemo: '/mnemo',
  Plans: '/plans',
  MeasuringPoints: '/measuring-points',
  ServerName: '/servername',
  Machines: '/machines',
  EquipmentGroups: '/groups',
  DeviceGroup: '/device-groups',
  GetAllNodes: '/nodes-state',
  GetAllDevices: '/nodes-state',
  Vp3711: '/ltr',
  Users: '/users',
  Auth: '/auth',
  Util: '/util',
  Controllers: '/controllers',
  Profile: '/profile'
} as const

export const ApiTag = {
  Connections: 'connections',
  Generators: 'generator',
  Machines: 'machines',
  Machine: 'machine',
  MeasuringPoints: 'measuring-points',
  MeasuringPoint: 'measuring-point',
  Measurements: 'measurements',
  MeasurementsTree: 'measurements-tree',
  Threshold: 'threshold',
  WorkMode: 'work-mode',
  Plans: 'plans',
  Plan: 'plan',
  Mnemo: 'mnemo',
  Info: 'info',
  Images: 'images',
  Vp3701Device: 'vp-3701',
  ServerName: 'server-name',
  GetAllNodes: 'get-all-nodes',
  GetAllDevices: 'get-all-devices',
  Kinematic: 'kinematic',
  Vp3711: 'vp-3711',
  EquipmentGroup: 'equipment-group',
  EquipmentGroups: 'equipment-groups',
  DeviceGroup: 'device-group',
  DeviceGroups: 'device-groups',
  Users: 'users',
  Auth: 'auth',
  Results: 'results',
  Util: 'util',
  Controllers: 'controllers',
  Profile: 'profile'
}
